import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

var firebaseConfig = {
  apiKey: "AIzaSyAV6zne8RGU2EplyK5C-jA0Jvn4v739bNo",
  authDomain: "oikos-785b4.firebaseapp.com",
  projectId: "oikos-785b4",
  storageBucket: "oikos-785b4.appspot.com",
  messagingSenderId: "760933833440",
  appId: "1:760933833440:web:a4315ce8cdb49e14128e85",
  measurementId: "G-4B3JVT3XB2",
};

firebase.initializeApp(firebaseConfig);
firebase.firestore();

export default firebase;
